module.exports = __webpack_public_path__ + "assets/img/company-territory.3815792a.jpg";